module.exports = __webpack_public_path__ + "img/home_pin.41ff15ca.svg";